import { runInAction } from 'mobx';
import { getLowestItemPrice, isDiscountItemPrice, isMemberRewardItemPrice } from '../../../sales-data/utils/items/item-price-utils';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
import { createDefaultInProgressItem } from '../../utils/items/create-default-in-progress-item';
export const createInProgressItemWithPrice = (sellableItem, selectedPrice) => {
    const lowestItemPrice = selectedPrice || getLowestItemPrice(sellableItem.prices);
    if (!lowestItemPrice)
        throw new Error(`Could not find lowest price for item ${sellableItem.itemId}`);
    const inProgressItem = createDefaultInProgressItem(sellableItem, lowestItemPrice);
    const inProgressItemWithPriceRestriction = Object.assign(Object.assign({}, inProgressItem), { rewardId: isMemberRewardItemPrice(lowestItemPrice) ? lowestItemPrice.rewardId : undefined, discountId: isDiscountItemPrice(lowestItemPrice) ? lowestItemPrice.discountId : undefined });
    runInAction(() => temporaryOrderDomainStore.data.inProgressItems.push(inProgressItemWithPriceRestriction));
};
